import { INGXLoggerConfig, NgxLoggerLevel } from 'ngx-logger';

export const LOGGER_DEFAULT_CONFIG: INGXLoggerConfig = {
  level: NgxLoggerLevel.TRACE,
  colorScheme: ['pink', 'green', 'blue', 'gray', 'orange', 'red', 'purple'],
};

export const AUTO_LOG_CATEGORY_FOR_LIB = 'SIGVLibrary';
export const AUTO_LOG_CATEGORY_FOR_TRANSLATE = 'LanguageChange';
